import React, { useCallback, useEffect, useState } from 'react'
import ACCOUNTS_MARKETPLACE_API from 'api/accounts-marketplace/v1'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import { notificationShow } from 'modules/Notifications/actions'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import isEmpty from 'lodash/isEmpty'
import clsx from 'clsx'
import styles from 'modules/AccountsMarketplace/Category/subcomponents/AccountCredentialsModal/account-credentials-modal.module.scss'

const AccountCredentialsModal = ({ closeModal, id }) => {
  const breakpoints = useBreakpoint()
  const [credentialsData, setCredentialsData] = useState({})
  const { t } = useTranslation()
  const writeToClipboard = useWriteToClipboard()
  const dispatch = useDispatch()

  const toClipboard = useCallback((text) => {
    writeToClipboard(text)

    dispatch(
      notificationShow({
        type: 'success',
        message: 'common::notifications.success_copy_notification',
      }),
    )
  }, [])

  useEffect(async () => {
    const { response, error } =
      await ACCOUNTS_MARKETPLACE_API.fetchOrderItemById({
        id,
      })

    if (error) {
      closeModal()
    } else {
      setCredentialsData(response.data)
    }
  }, [id])

  return isEmpty(credentialsData) ? (
    <GridSpinner width={40} />
  ) : (
    <>
      <Grid direction={'column'} gap={24} className={'margin-bottom-32'}>
        <Typography variant={'Body-25'} component={'p'}>
          {credentialsData.product_name
            .replace(/\r\n/gm, '<br />')
            .replace('\u00A0', ' ')}
        </Typography>

        <Grid>
          <Typography
            variant={'Subtitle-20'}
            color={'Label-Secondary'}
            className={'margin-bottom-8'}
            component={'h5'}
          >
            {t(
              'accounts_marketplace::category.account_credential_modal.description_header',
            )}
          </Typography>
          <Typography
            component={'p'}
            variant={'Body-20'}
            dangerouslySetInnerHTML={{
              __html: credentialsData.product_description
                .replace(/\r\n/gm, '<br />')
                .replace('\u00A0', ' '),
            }}
          />
        </Grid>

        <Grid>
          <Typography
            component={'h5'}
            variant={'Subtitle-20'}
            color={'Label-Secondary'}
            className={'margin-bottom-8'}
          >
            {t(
              'accounts_marketplace::category.account_credential_modal.login_data_header',
            )}
          </Typography>

          <Grid gap={8} direction={'column'}>
            {credentialsData.credentials.map((cred, i) => (
              <Grid
                gap={8}
                key={'credential-' + i}
                alignItems={'flex-start'}
                wrap={false}
              >
                <Col
                  className={clsx(
                    'cursor_pointer',
                    styles['copy-icon__wrapper'],
                  )}
                  onClick={() => toClipboard(cred)}
                  title={t(
                    'accounts_marketplace::category.account_credential_modal.copy_credential',
                  )}
                >
                  <Icon name={'copy'} size={'s'} color={'Label-GU-Primary'} />
                </Col>
                <Col>
                  <Typography
                    variant={'Body-20'}
                    className={styles['credential-text']}
                  >
                    {cred}
                  </Typography>
                </Col>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid justifyContent={!breakpoints.md ? 'center' : 'flex-end'}>
        <Button
          variant={'primary'}
          onClick={closeModal}
          fullWidth={!breakpoints.md}
        >
          {t('accounts_marketplace::category.account_credential_modal.close')}
        </Button>
      </Grid>
    </>
  )
}

export default AccountCredentialsModal

AccountCredentialsModal.propTypes = {
  id: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
}
